module.exports = (__parcel__import__("hGxag")).then(() => parcelRequire('fyWP3'));